import { render } from "./KSUsluge.vue?vue&type=template&id=00954ce0&scoped=true&lang=html"
import script from "./KSUsluge.vue?vue&type=script&lang=js"
export * from "./KSUsluge.vue?vue&type=script&lang=js"

import "./KSUsluge.vue?vue&type=style&index=0&id=00954ce0&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-00954ce0"

export default script